import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const markAsEndCallLog = async (callLogId: number) => {
  const response = await mutationExecute({
    variables: {
      callLogId,
    },
    mutation: graphql(`
      mutation MarkAsEndCallLog($callLogId: Float!) {
        markAsEndCallLog(callLogId: $callLogId) {
          id
          timeEnd
        }
      }
    `),
  });

  return !!response.data?.markAsEndCallLog;
};
